import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { FooterModule } from 'src/app/components/footer/footer.module';
import { PublicTopNavigationModule } from './components/top-navigation/public-top-navigation.module';
import { PublicComponent } from './public.component';
import { PrivacyPolicyComponent } from 'src/app/components/footer/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from 'src/app/components/footer/terms-and-conditions/terms-and-conditions.component';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      { path: '', loadChildren: () => import('./home/home.module').then((m) => m.HomeModule) },
      { path: 'carriers', loadChildren: () => import('./carriers/carriers.module').then((m) => m.CarriersModule) },
      { path: 'bmi', loadChildren: () => import('./../../components/bmi/bmi.module').then((m) => m.BmiModule) },
      { path: 'form-components', loadChildren: () => import('./form-components/form-components.module').then((m) => m.FormComponentsModule) },
      { path: 'e-card', loadChildren: () => import('./e-card/e-card.module').then((m) => m.ECardModule) },
      { path: 'video', loadChildren: () => import('./videos/videos.module').then((m) => m.VideoModule) },
      { path: 'about', loadChildren: () => import('./about/about.module').then((m) => m.AboutModule) },
      { path: 'landing', loadChildren: () => import('./landing/landing-page.module').then((m) => m.LandingPageModule) },
      { path: 'article', loadChildren: () => import('./ltc-conversation/ltc-conversation.module').then((m) => m.LtcConversationModule) },
      { path: 'cookie-policy', loadChildren: () => import('./../../components/cookie-policy/cookie-policy.module').then((m) => m.CookiePolicyModule) },
      { path: 'privacy-policy', component: PrivacyPolicyComponent },
      { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
    ],
  },
];

@NgModule({
  declarations: [PublicComponent],
  exports: [RouterModule],
  imports: [CommonModule, RouterModule.forChild(routes), ComponentsModule, PublicTopNavigationModule, FooterModule],
})
export class PublicModule {}
